import {
  PRIMNAV_INIT,
  PRIMARY_TAB_ACTIVE,
  PRIMARY_TAB_DEACTIVE,
  PRIMARY_TABS_UPDATE_RECT,
  SUBNAV_INIT,
  UPDATE_DIVISION,
  SHOW_CATEGORIES_FLYOUT,
  SHOW_CATEGORY_FLYOUT_ITEM,
} from 'app/common/constants/action-types';
import { loadNavigationData } from 'app/desktop/helpers/navigation';
import { filterByCampaign } from 'app/common/helpers/utm_params';

let hideFlyouts = null;

export function updateTabBound(id) {
  const tab = document.getElementById(`${id}-tab`).querySelector(`a`);

  const { left, width } = tab.getBoundingClientRect();
  const rect = { id, left, width };

  return {
    type: PRIMARY_TABS_UPDATE_RECT,
    rect,
  };
}

export function showFlyout(tab) {
  if (hideFlyouts) {
    window.clearTimeout(hideFlyouts);
  }

  return (dispatch, getState) => {
    const { navbar } = getState();
    if (navbar.activeTab === tab) {
      return;
    }

    dispatch({ type: PRIMARY_TAB_ACTIVE, tab });
  };
}

export function showCategoriesFlyout() {
  return { type: SHOW_CATEGORIES_FLYOUT };
}

export function showCategoryFlyoutItem(activeCategory) {
  return { type: SHOW_CATEGORY_FLYOUT_ITEM, activeCategory };
}

export function hideAllFlyouts() {
  return (dispatch, getState) => {
    const { navbar } = getState();
    if (!navbar.activeTab) {
      return;
    }

    if (hideFlyouts) {
      window.clearTimeout(hideFlyouts);
    }

    hideFlyouts = window.setTimeout(() => {
      dispatch({ type: PRIMARY_TAB_DEACTIVE });
    }, 250);
  };
}

export function loadSubnav() {
  return (dispatch, getState) => {
    const { flags, location, flyouts, cards } = getState();
    if (
      flags.showLiteHeader ||
      (flyouts &&
        Object.keys(flyouts).length &&
        Array.isArray(cards) &&
        cards.length)
    ) {
      return;
    }

    loadNavigationData(location.division, flags.desktopHeader2019)
      .then(data => {
        data.primary = filterByCampaign(data.primary);

        dispatch({
          type: PRIMNAV_INIT,
          ...data,
        });
        if (window.shellLayout) {
          dispatch({
            type: UPDATE_DIVISION,
            ...data,
          });
        }
        dispatch({
          type: SUBNAV_INIT,
          ...data,
          isRedesign: flags.desktopHeader2019,
        });
      })
      .catch(() => {});
  };
}

export function updateCouponLinks(couponsSubnavLinks) {
  return {
    type: 'SUBNAV_UPDATE_COUPONS',
    couponsSubnavLinks,
  };
}
